import IconFont from '@meitu/xdesign-icon-font';
import { getFramework, ResourceThumbnail } from '@/framework';
import { getLocaleStore } from '@/i18n/index';
import { base64Kit } from '@/utils/base64-kit';
import type { IChartLayerProps, ILayerBehavior, ILayerProps } from '@/version-types';
import { EdgelessChartLayer } from '../edgeless-layer';
import { ChartHoverOperate } from '../operate/chart-hover-operate';

type Behaviors = Pick<
    ILayerBehavior,
    | 'getEdgelessObject'
    | 'customHoverOperate'
    | 'customActiveOperate'
    | 'previewToImage'
    | 'getMenuOverlapName'
    | 'getMenuOverlapIcon'
>;

export const createRendererBehaviors = (frameworkIdentity: string) => {
    const behaviors: Behaviors = {
        getEdgelessObject(layer: ILayerProps) {
            return new EdgelessChartLayer(layer.id, getFramework(frameworkIdentity));
        },

        customHoverOperate(layer: ILayerProps) {
            return <ChartHoverOperate layer={layer} mode="hover" />;
        },

        customActiveOperate(layer: ILayerProps) {
            return <ChartHoverOperate layer={layer} mode="active" />;
        },

        previewToImage: () => false,

        getMenuOverlapName() {
            const { $t } = getLocaleStore();
            return $t((v) => v.layers.chart);
        },

        getMenuOverlapIcon(layer) {
            if (layer.width <= 0 || layer.height <= 0) {
                return <IconFont name="StackedColumnGraph" fontSize={16} />;
            }

            const resource = getFramework(frameworkIdentity).service.edgelessCanvas.getByLayerId(layer.id)?.resource;
            const { screenshotUrl } = layer.data as IChartLayerProps;
            return (
                <ResourceThumbnail
                    resource={resource}
                    fallbackIcon={<IconFont name="StackedColumnGraph" fontSize={16} />}
                    fallbackUrl={screenshotUrl ? base64Kit.getLocalUrl(screenshotUrl) : null}
                />
            );
        },
    };

    return behaviors;
};
